"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getUserDimensions;
/**
 * js-utils-apm
 *
 * Copyright © 2016 Appfolio, Inc. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function getUserDimensions() {
  var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var browserWidth = win.innerWidth || -1;
  var browserHeight = win.innerHeight || -1;
  var screenWidth = win.screen && win.screen.width || -1;
  var screenHeight = win.screen && win.screen.height || -1;
  return {
    browserWidth: browserWidth,
    browserHeight: browserHeight,
    screenWidth: screenWidth,
    screenHeight: screenHeight
  };
}